export const matchUrlPath = (pathname: string, matches: RegExp[]): boolean => {
  for (const match of matches) {
    if (match.test(pathname)) return true;
  }
  return false;
};
